import React, { useCallback, useState } from 'react';
import { Grid, GridItem } from 'components/UI/Grid';
import Card from './Card';
import { useTrans } from 'utils/localisation';

import * as styles from './ContentItem.module.scss';

export default function ContentItem({ cards, limiter = 3 }) {
  const t = useTrans(['common']);

  const [showCount, setShowCount] = useState(limiter);

  const showMoreHandle = useCallback(() => {
    setShowCount(prev => prev + limiter);
  }, [limiter]);

  const hiddenItems = cards?.length - showCount;

  const gridSettings = {
    xsm: { cols: 1, gutterX: '20px', gutterY: '20px' },
    sm: { cols: 2, gutterX: '20px', gutterY: '20px' },
    md: { cols: 3, gutterX: '20px', gutterY: '40px' },
    lg: { cols: 3, gutterX: '20px', gutterY: '40px' },
    xl: { cols: 3, gutterX: '30px', gutterY: '40px' },
  };

  return (
    <div className={styles.wrapper}>
      <Grid {...gridSettings}>
        {cards?.slice(0, showCount).map(card => (
          <GridItem key={card.id}>
            <Card {...card} />
          </GridItem>
        ))}
      </Grid>
      {showCount < cards?.length && (
        <div className={styles.buttonRow}>
          <button className={styles.button} onClick={showMoreHandle}>
            {`${t('seeMore')} (${hiddenItems})`}
          </button>
        </div>
      )}
    </div>
  );
}
